import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    stepper: {
        border: 'none',
        display: 'flex',
        overflow: 'visible',
        height: '2.5em',
        marginBottom: 5,
        background: theme.palette.white.main,
    },
    stepperInput: {
        fontSize: '1rem',
        fontWeight: 'bold',
        width: '3rem',
        height: '100%',
        textAlign: 'center',
        borderLeft: 'none',
        borderRight: 'none',
        borderBottom: '2px solid rgb(116,116,116)',
        borderTop: '2px solid rgb(116,116,116)',
        background: 'transparent',
        color: theme.palette.black,
        verticalAlign: 'top',
    },
    stepperButton: {
        width: '1.7em',
        height: '100%',
        lineHeight: 1,
        fontSize: '1.5em',
        fontWeight: 'bold',
        color: '#005C59',
        background: '#F4F4F4',
        borderColor: 'rgb(116,116,116)',
        borderWidth: '2px',
        borderStyle: 'solid',
        cursor: 'pointer',
        transition: 'background-color .2s',
    },
    stepperDecrementButton: {
        borderRadius: '99px 0 0 99px',
    },
    stepperIncrementButton: {
        borderRadius: '0 99px 99px 0',
    },
}))

const CartItemQuantityStepper = ({
    cartId,
    cartItemId,
    quantity,
    updateCart,
    setErrors,
}) => {
    const classes = useStyles()

    return (
        <span className={classes.stepper}>
            <button
                className={`${classes.stepperButton} ${classes.stepperDecrementButton}`}
                onClick={() => {
                    updateCart({
                        cart_id: cartId,
                        cart_items: [
                            {
                                item_id: cartItemId,
                                quantity: quantity - 1,
                            },
                        ],
                    })
                    setErrors([])
                }}
            >
                –
            </button>
            <input
                className={`${classes.stepperInput} browser-default`}
                type="number"
                value={quantity}
                min={0}
                max={30}
                step={1}
                readOnly
            />
            <button
                className={`${classes.stepperButton} ${classes.stepperIncrementButton}`}
                onClick={() => {
                    updateCart({
                        cart_id: cartId,
                        cart_items: [
                            {
                                item_id: cartItemId,
                                quantity: quantity + 1,
                            },
                        ],
                    })
                    setErrors([])
                }}
            >
                +
            </button>
        </span>
    )
}

export default CartItemQuantityStepper
